import React from 'react';
import { Box } from '@mui/material';
import CSVDragDropUpload from '../../Prospect/CSVDragDropUpload';

interface UploadStepProps {
  onFileParsed: (file: File) => void;
}

const UploadStepContent: React.FC<UploadStepProps> = ({ onFileParsed }) => {
  return (
    <Box>
      <CSVDragDropUpload onFileParsed={onFileParsed} />
    </Box>
  );
};

export default UploadStepContent;
